// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card[data-v-db53f142] {\n  height: 100%;\n}\n.icon.md-alert-circle-o[data-v-db53f142] {\n  font-size: 100px;\n}", ""]);
// Exports
module.exports = exports;
